import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { reportFilterShape, reportShape, reportCreateShape } from './models'
import { z } from 'zod'

const generateReportInputShape = {
  id: z.string().uuid(),
  templateId: z.string().uuid().optional().nullable(),
}

const generateReport = createCustomServiceCall({
  inputShape: generateReportInputShape,
  outputShape: reportShape,
  cb: async ({ client, input, utils }) => {
    const body = input.templateId ? { template_id: input.templateId } : {}
    const res = await client.post(`/expenses/expense-report/${input.id}/generate-report/`, body)
    return utils.fromApi(res.data)
  },
})

const cancelReport = createCustomServiceCall({
  inputShape: z.string().uuid(),
  outputShape: reportShape,
  cb: async ({ client, input, utils }) => {
    const res = await client.post(`/expenses/expense-report/${input}/cancel-report/`)
    return utils.fromApi(res.data)
  },
})

const downloadReport = createCustomServiceCall({
  inputShape: z.string().uuid(),
  outputShape: z.string(),
  cb: async ({ client, input }) => {
    const res = await client.get(`/expenses/expense-report/${input}/download-report/`, {
      responseType: 'blob',
    })

    return res.headers['content-disposition'].split('filename=')[1]
  },
})

export const expenseReportsApi = createApi({
  client: axiosInstance,
  baseUri: '/expenses/expense-report/',
  models: {
    entity: reportShape,
    create: reportCreateShape,
    extraFilters: reportFilterShape,
  },
  customCalls: {
    generateReport,
    cancelReport,
    downloadReport,
  },
})
